// extracted by mini-css-extract-plugin
export var actionButton = "_5v-1";
export var actionButtons = "_5v-2";
export var actions = "_5v-0";
export var aiUnread = "_5v-10";
export var alignCenter = "_5v-h";
export var backWrapper = "_5v-3";
export var cellContainer = "_5v-4";
export var checkboxContainer = "_5v-5";
export var contentContainer = "_5v-6";
export var contentHeader = "_5v-8";
export var conversationsTableWrapper = "_5v-s";
export var draftReplyBadgeContainer = "_5v-m";
export var dropdownItem = "_5v-b";
export var dropdownItemsContainer = "_5v-a";
export var dropdownTitle = "_5v-c";
export var errorIcon = "_5v-7";
export var filter = "_5v-d";
export var gray = "_5v-i";
export var headerActionButtons = "_5v-e";
export var headerCheckboxContainer = "_5v-f";
export var icon = "_5v-j";
export var menuContainer = "_5v-k";
export var noMoreTicketsIcon = "_5v-12";
export var noMoreTicketsSubText = "_5v-13";
export var oneLine = "_5v-l";
export var optionsButton = "_5v-n";
export var plus = "_5v-o";
export var portalButtonsWrapper = "_5v-g";
export var red = "_5v-p";
export var scrolledTop = "_5v-9";
export var search = "_5v-q";
export var selectedConversationsCount = "_5v-r";
export var spinner = "_5v-t";
export var strong = "_5v-u";
export var summaryCell = "_5v-v";
export var tableContainer = "_5v-11";
export var tagContainer = "_5v-w";
export var threeDots = "_5v-x";
export var twoLines = "_5v-y";
export var unread = "_5v-z";